<template>
	<div class="pt-2">
		<CommonFlame :title="title">
			<template v-slot:app-bar-btn>
				<ConstructionWorkerNewDialog
					v-if="authority_flag && !$vuetify.breakpoint.xs"
					:qualifications="qualifications"
					text
					@click="fetchWorkers($event)"
				/>
			</template>
			<v-row no-gutters justify="end">
				<ConstructionWorkerNewDialog
					v-if="authority_flag && $vuetify.breakpoint.xs"
					:qualifications="qualifications"
					@click="fetchWorkers($event)"
				/>
			</v-row>
			<div class="table-container mt-4">
				<v-data-table
					locale="ja-JP"
					:items="workers"
					:headers="headers"
					:mobile-breakpoint="240"
					hide-default-footer
					disable-filtering
					disable-pagination
					disable-sort
					no-data-text="データがありません。"
				>
					<template v-slot:item="{ item }">
						<tr
							@click="authority_flag ? openDialog(item) : false"
							:class="{ 'no-click': !authority_flag }"
						>
							<td>XX XX</td>
							<td>XXXXXX</td>
							<td>XXXXXXX<br />XXXXX</td>
							<td>XXX-XXXX</td>
							<td>XXX XXXX XXXXX</td>
							<td>XXX-XXXX-XXXX</td>
							<td>X</td>
							<td>XXXX/XX/XX</td>
							<td>XXXXXXXXXX</td>
							<td>XXXXX.pdf<br />XXX.png</td>
							<td>XXX-XXXX-XXXX</td>
							<td>XX XX</td>
							<td>XX</td>
						</tr>
					</template>
				</v-data-table>
			</div>
			<PaginationModule :pagination="pagination" @get-page="getPage($event)"></PaginationModule>
		</CommonFlame>
		<ConstructionWorkerEditDialog
			v-if="authority_flag"
			:dialog.sync="dialog"
			:selectedWorker="selectedWorker"
			:authorityFlag="authority_flag"
			:qualifications="qualifications"
			@update-worker="fetchWorkers(pagination.current)"
		/>
	</div>
</template>

<script>
import axios from "axios"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import CommonFlame from "../shared/CommonFlame.vue"
import PaginationModule from "../../modules/PaginationModule.vue"
import ConstructionWorkerEditDialog from "./worker_components/ConstructionWorkerEditDialog.vue"
import ConstructionWorkerNewDialog from "./worker_components/ConstructionWorkerNewDialog.vue"

export default {
	components: {
		CommonFlame,
		PaginationModule,
		ConstructionWorkerEditDialog,
		ConstructionWorkerNewDialog,
	},
	data() {
		return {
			title: "作業者一覧",
			authority_flag: false,
			headers: headers(),
			workers: [],
			qualifications: [],
			pagination: {
				count: null,
				current: 1,
				limit_value: null,
				next: null,
				pages: null,
				previous: null,
			},
			selectedWorker: null,
			dialog: false,
		}
	},

	mounted() {
		const page = this.$route.query.page ? this.$route.query.page : 1
		// this.fetchWorkers(page)
		// レイアウト用
		this.authority_flag = true
		this.workers = [...Array(5)].map((_, i) => ({ id: i }))
		this.qualifications = [
			{ name: "有機溶剤作業主任者" },
			{ name: "酸素欠乏危険作業主任者" },
			{ name: "職長安全衛生責任者" },
			{ name: "自由研削砥石特別教育" },
			{ name: "フルハーネス型安全帯使用作業特別教育" },
		]
	},
	methods: {
		fetchWorkers(page) {
			const headers = authenticate.setHeader()
			const params = { page }
			axios
				.get("/erp/v1/constructions/workers", {
					params,
					headers,
				})
				.then((response) => {
					this.workers = response.data.workers
					this.qualifications = response.data.qualifications
					this.pagination = response.data.pagination
					this.authority_flag = response.data.authority_flag
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		openDialog(item) {
			this.selectedWorker = item
			this.dialog = true
		},
		getPage(page) {
			this.fetchWorkers(page)
			this.$router.push({
				name: this.$route.name,
				query: { page: page },
			})
			window.scrollTo({
				top: 0,
				behavior: "smooth",
			})
		},
	},
}

function headers() {
	// TODO: Valueを入力
	return [
		{ text: "名前", value: "", width: "120px" },
		{ text: "所属", value: "", width: "120px" },
		{ text: "資格", value: "", width: "200px" },
		// { text: "所属(正式名称)", value: "", width: "200px" },
		{ text: "郵便番号", value: "", width: "100px" },
		{ text: "住所", value: "", width: "200px" },
		{ text: "電話番号", value: "", width: "150px" },
		{ text: "血液型", value: "", width: "80px" },
		{ text: "誕生日", value: "", width: "120px" },
		{ text: "備考", value: "", width: "200px" },
		{ text: "添付資料", value: "", width: "200px" },
		{ text: "緊急連絡先", value: "", width: "150px" },
		{ text: "相手の名前", value: "", width: "120px" },
		{ text: "作業者との関係", value: "", width: "120px" },
	]
}
</script>
